import {
  LoanCaseDTO,
  ProductInstanceDTO,
  ProductInstanceProductCodeEnum,
  ValueList,
} from "@smartx/mikro-vt-client-api"
import dayjs from "../utils/dayjs"
import { productCodes } from "./caseHelper"

export const getCvtValue = (
  valueLists: ValueList[],
  listName: string,
  code: string,
) => {
  const list = valueLists?.find((vl) => vl.valueListCode === listName)
  return list?.values?.find((el) => el.code === code)?.value
}

export const isPbCase = (loanCase: LoanCaseDTO): boolean =>
  loanCase ? isPb(loanCase.productCode) : false

export const isPb = (productCode: ProductInstanceProductCodeEnum): boolean => {
  return [
    productCodes.EH,
    productCodes.FH,
    productCodes.EHFH,
    productCodes.EXIT,
  ].includes(productCode)
}

export const isSzkCase = (loanCase: LoanCaseDTO): boolean =>
  loanCase ? isSzk(loanCase.productCode) : false

export const isSzk = (productCode: ProductInstanceProductCodeEnum): boolean => {
  return [
    productCodes.SZKEH,
    productCodes.SZKFH,
    productCodes.BSZKEH,
    productCodes.ASZKFH,
  ].includes(productCode)
}

export const isPalCase = (loanCase: LoanCaseDTO): boolean =>
  loanCase ? isPal(loanCase.productCode) : false

export const isPal = (productCode: ProductInstanceProductCodeEnum): boolean =>
  productCode === productCodes.PALFH

export const isBiancoCase = (loanCase: LoanCaseDTO): boolean =>
  loanCase ? isBianco(loanCase.productCode) : false

export const isBianco = (
  productCode: ProductInstanceProductCodeEnum,
): boolean => productCode === productCodes.BIANCO

export const isEhProduct = (product: ProductInstanceDTO): boolean =>
  [
    productCodes.EH,
    productCodes.EXIT,
    productCodes.SZKEH,
    productCodes.BSZKEH,
  ].includes(product?.productCode) || product?.biancoProductType === "EH"

export const isFhProduct = (product: ProductInstanceDTO): boolean =>
  [
    productCodes.FH,
    productCodes.SZKFH,
    productCodes.ASZKFH,
    productCodes.PALFH,
  ].includes(product?.productCode) || product?.biancoProductType === "FH"

export const getDateDiffInDays = (
  dateValue: string,
  isPast?: boolean,
): number => {
  const today = dayjs().startOf("day")
  const checkDate = dateValue ? dayjs(dateValue).startOf("day") : null

  return isPast ? today.diff(checkDate, "days") : checkDate.diff(today, "days")
}

export const formatDateString = (input: string): string => {
  const digits = input.replaceAll(/\D/g, "")

  if (digits.length !== 8) {
    return input
  }

  const year = digits.slice(0, 4)
  const month = digits.slice(4, 6)
  const day = digits.slice(6, 8)

  return `${year}-${month}-${day}`
}

export const parseBookingDateTime = (input: string): string => {
  if (!input) return input
  const match = /^(\d{4})\.(\d{2})\.(\d{2})\.?\s+(\d{2}:\d{2}:\d{2})$/.exec(
    input,
  )
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}T${match[4]}`
  }
  return input
}

export const createDateVariable = (input: string): Date => {
  if (!input) {
    return null
  }

  const year = Number.parseInt(input.substring(0, 4), 10)
  const month = Number.parseInt(input.substring(4, 6), 10) - 1
  const day = Number.parseInt(input.substring(6, 8), 10)

  return new Date(year, month, day)
}
